import styled, { css } from "styled-components";

import { SimpleUserInitialsNameContainer } from "shared/components/atoms/SimpleUserInitials/styles";
import { SimpleUserPhotoContainer } from "shared/components/atoms/SimpleUserPhoto/styles";

import { LexicalEditorInnerContainer } from "@LexicalEditor/component/organisms/LexicalEditorInner/styles";
import { EditorToolbar } from "@LexicalEditor/plugins/ToolbarPlugin/styles";
import { EditorContainer } from "@LexicalEditor/styles";
import { DialogBase } from "@LexicalEditor/styles/DialogBase";
import { EditorDropdown } from "@LexicalEditor/styles/EditorDropdown";

interface IButtonContainerProps {
  isActive: boolean;
}
export const ButtonContainer = styled.div<IButtonContainerProps>`
  display: flex;
  justify-content: flex-end;
  transition: all var(--editor-collapse-animation-time) ease-in-out;
  gap: ${({ isActive }) => (isActive ? "0.5rem" : "0")};

  padding: ${({ isActive }) =>
    isActive ? "0 0.5rem 0.5rem 0 !important" : "0"};

  button {
    pointer-events: ${({ isActive }) => (isActive ? "all" : "none")};
    width: fit-content;
    color: #f2f2f2;

    height: ${({ isActive }) => (isActive ? "auto" : "0")};
    padding: ${({ isActive }) => (isActive ? "0.5rem 1rem !important" : "0")};

    :not(:disabled):hover {
      cursor: pointer;
    }

    :disabled:hover {
      cursor: not-allowed;
    }

    ${({ isActive }) =>
      isActive
        ? css`
            opacity: 1;
            :disabled {
              opacity: 0.2;
            }
          `
        : css`
            opacity: 0 !important;
          `}
  }
`;

export const LexicalEditorContainer = styled.div`
  transition: all var(--editor-collapse-animation-time) ease-in-out;

  transition: border 0.3s !important;

  border-radius: 4px;
  border: 1px solid #ffffff14;
  background-color: #131214;

  align-items: end;
  display: flex;
  flex-direction: column;

  width: 100%;

  > .loader {
    align-self: center;
    margin: 1rem 0;
  }
`;

interface ICreateCommentEditorFeedContainerProps {
  isActive: boolean;
}
export const CreateCommentEditorFeedContainer = styled.div<ICreateCommentEditorFeedContainerProps>`
  --padding-button-xs: 6px;

  box-shadow: none !important;

  display: flex;
  position: relative;
  align-items: flex-start;
  gap: 0.5rem;

  transition: all var(--editor-collapse-animation-time) ease-in-out;

  margin-bottom: 1rem !important;

  @media (max-width: 900px) {
    border-radius: 0;
  }

  @media (max-width: 768px) {
    display: grid;
    gap: 0.5rem;
    grid-template-columns: auto 1fr;

    ${ButtonContainer} {
      grid-row: 2;
      grid-column: 1/-1;
    }
  }

  ${SimpleUserPhotoContainer},
  ${SimpleUserPhotoContainer} > img,
  ${SimpleUserInitialsNameContainer} {
    width: 29px !important;
    height: 29px !important;
    h1 {
      background-color: ${({ theme }) => theme.groups.primaryText};
    }
  }

  ${LexicalEditorInnerContainer} {
    .editor-input {
      border: none;
      min-height: min-content;
    }
  }

  ${EditorContainer} {
    position: initial;

    display: flex;
    flex-direction: column-reverse;
  }

  ${DialogBase},
  ${EditorDropdown} {
    width: min-content;
    max-width: min-content;
    bottom: 0.25rem;
    top: unset;
  }

  ${DialogBase} {
    min-width: 10rem;
  }

  ${EditorToolbar} {
    transition: all 0.1s ease-in-out;
    opacity: ${({ isActive }) => (isActive ? "1" : "0")};
    pointer-events: ${({ isActive }) => (isActive ? "all" : "none")};
    height: ${({ isActive }) => (isActive ? "auto" : "0")};
    padding: ${({ isActive }) => (isActive ? "4px" : "0")};
    overflow: hidden;
    gap: 0.25rem;
    margin-right: 5.5rem;
    border: none;

    button {
      padding: var(--padding-button-xs);
    }
  }

  .editor-lexical {
    ${EditorToolbar},
    .editor-input {
      border: none;
      min-height: auto;
    }

    .editor-input {
      padding: 0.5rem;
    }

    .editor-placeholder {
      vertical-align: middle;
      left: 1rem;
      top: 0.5rem;
    }
  }

  .userInitials {
    padding-top: 0.5rem;
  }

  :has(.editor-input:focus) {
    ${LexicalEditorContainer} {
      border-color: #40a0ff !important;
    }
  }
`;
